export const RETRY_TIMEOUT_MS = 60000;
export const DASHBOARD_POLL_INTERVAL_MS = 18000;
export const CHART_AXIS_TICK_FONT_SIZE_PX = 11;
export const CHART_HEIGHT_PX = 260;